export const EXATOM_URL = 'https://exatom.io/?utm_source=form-audit-website'
export const PRICING_URL = 'https://exatom.io/pricing'
export const PRIVACY_URL = 'https://exatom.io/privacy-policy'
export const TERMS_URL = 'https://exatom.io/terms-of-use'
export const LOGIN_URL = 'https://olympus.exatom.io'
export const SIGNUP_URL = 'https://olympus.exatom.io/signup'
export const CHROME_EXTENSION_URL = 'https://chromewebstore.google.com/detail/exatom-webform-audit/gafmmfoddcaabpmapakfafphlikdkpoj'
export const SCORES_URL = 'https://exassets.s3.eu-central-1.amazonaws.com/scores/'
